var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTemplateBuilder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2975_24816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5698 0.859375H1.4269C1.11083 0.859375 0.855469 1.11473 0.855469 1.4308V14.5737C0.855469 14.8897 1.11083 15.1451 1.4269 15.1451H14.5698C14.8858 15.1451 15.1412 14.8897 15.1412 14.5737V1.4308C15.1412 1.11473 14.8858 0.859375 14.5698 0.859375ZM2.14118 2.14509H4.56976V13.8594H2.14118V2.14509ZM13.8555 13.8594H5.71261V5.71652H13.8555V13.8594ZM5.71261 4.57366V2.14509H13.8555V4.57366H5.71261Z",
    fill: "#111827"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2975_24816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTemplateBuilder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/templateBuilder.f732a33174cf7b2f58c78fa3694fcccf.svg";